import { post, get, ERROR_TYPE, ERROR_MESSAGE } from "@/utils/request";
import {
  MGMPageInfo,
  PopupInfo,
  RuleDetail,
  ShareInfo,
  M2PageInfo,
  RegisterResult,
  M2RegisterParams,
  InvitationListResponse,
  HistoricalActivitiesResponse,
  HistoricalActivitiesParams,
} from "./types";
import { RISK_SDK_VERSION } from "@/components/RiskVerify/constants";
import BusinessVerify, { EnumBusinessFlow } from "@/components/BusinessVerify";
import { DefaultConfigs, inApp } from "@/common/js/constant";
import APP from "@/utils/app";
import { trackEvent, setCommonAttrs } from "@/utils/omega";
import { i18nTranslate } from "@didi/i18n-plugin";

const BASE_URL = `${DefaultConfigs.publicAPIPath}/sofipo`;

// M1 APIs
export const getM1PageInfo = () => {
  return post<MGMPageInfo>(`${BASE_URL}/v0/marketing/mgm/m1/page`, {});
};

export const getInvitationList = (type: "unfinished" | "completed", page: number) => {
  return post<InvitationListResponse>(`${BASE_URL}/m1/invitation/list`, { type, page });
};

export const getM1Popup = () => {
  return post<PopupInfo>(`${BASE_URL}/v0/marketing/mgm/m1/popup`, {});
};
// M1 退出弹窗
export const getM1LeavePopup = () => {
  return post<PopupInfo>(`${BASE_URL}/v0/marketing/mgm/m1/leave/popup`, {}, {});
};
// M1 规则详情
export const getRuleDetail = () => {
  return get<RuleDetail>(`${BASE_URL}/v0/marketing/mgm/rule/detail`, {});
};

// M1 分享
export const shareM1 = (
  channelCode: "whatsapp" | "other",
  resourceId: number,
  resource_id: string,
) => {
  return post<ShareInfo>(
    `${BASE_URL}/v0/marketing/mgm/m1/share`,
    { channelCode, resourceId, resource_id },
    {},
  );
};

// M1 历史活动
export const getHistoricalActivities = (
  params: HistoricalActivitiesParams,
): Promise<HistoricalActivitiesResponse> => {
  // TODO: 接口实现完成后移除 mock
  return post<HistoricalActivitiesResponse>(`${BASE_URL}/v0/marketing/mgm/m1/history`, params);

  // Mock 数据返回 - 30% 概率返回空数据
  // return new Promise((resolve) => {
  //     setTimeout(() => {
  //         resolve(getRandomMockData());
  //     }, 300);
  // });
};

// M2 APIs
export const getM2PageInfo = (
  uuid: string,
  shareCode: string,
  channel: string,
  resourceId: string,
) => {
  return post<M2PageInfo>(`${BASE_URL}/v0/marketing/mgm/m2/page`, {
    uuid,
    shareCode,
    channel,
    resourceId,
  });
};

export const registerM2 = async (params: M2RegisterParams): Promise<RegisterResult> => {
  // 核验版本
  params.verifyInfo = params.verifyInfo || {
    verifySdkVersion: RISK_SDK_VERSION,
  };
  try {
    return await post<RegisterResult>(`${BASE_URL}/v0/marketing/mgm/m2/register`, params);
  } catch (ret: any) {
    console.log(ret);
    // 业务核验
    if (ret.errno === ERROR_TYPE.BusinessVerify) {
      // 核验拉起时禁止返回按钮
      if (inApp) {
        APP.requestBackPressedControl(() => {});
      }
      // 设置公参
      setCommonAttrs({
        // scene_source
        // 场景来源
        // 0-风控
        // 1-业务
        scene_source: BusinessVerify.scene,
        // from_source 流程来源
        from_source: EnumBusinessFlow.mgm,
      });

      // 拉起核验
      return new BusinessVerify()
        .verify(ret?.data?.bussVerifyResultInfo)
        .then((res) => {
          // 重置公参
          setCommonAttrs({
            // scene_source
            // 场景来源
            // 0-风控
            // 1-业务
            scene_source: undefined,
            // from_source 流程来源
            from_source: undefined,
          });
          // 释放控制
          if (inApp) {
            APP.cancelBackPressedControl();
          }
          // 增加核验token
          if (params.verifyInfo) {
            params.verifyInfo.sessionId = res.verify_session_id;
            // 核验完成
            params.verifyInfo.bussVerify = 1;
            params.sessionId = res.verify_session_id;
          }
          // 重新发起请求
          return registerM2(params);
        })
        .catch((err) => {
          // 释放控制
          if (inApp) {
            APP.cancelBackPressedControl();
          }
          // 技术打点
          trackEvent("tech_sofi_catch_error", {
            source: "mgm.m2.BusinessVerify",
            data: JSON.stringify(ret.name + ret.message || ret),
          });

          // 风控核验失败
          if (err.message === ERROR_MESSAGE.RiskVerifyFailed) {
            return Promise.reject({
              message: i18nTranslate("Fintech_Payment_2_WgYE_UdrG"),
            });
          }
          // 交给上层catch
          return Promise.reject(err);
        });
    }
    // 释放控制
    if (inApp) {
      APP.cancelBackPressedControl();
    }

    // 技术打点
    trackEvent("tech_sofi_catch_error", {
      source: "mgm.m2.register",
      data: JSON.stringify(ret.name + ret.message || ret),
    });

    // 交给上层catch
    return Promise.reject(ret);
  }
};
